import { render, staticRenderFns } from "./CreatePrecios.vue?vue&type=template&id=b112bdc0&"
import script from "./CreatePrecios.vue?vue&type=script&lang=js&"
export * from "./CreatePrecios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports